export default __webpack_public_path__ + "static/media/payt.d84533a8.png";